var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"arrive-notice-wrap"},[(_vm.props.useIcon)?_c('div',{staticClass:"mc-icon-wrap",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.listeners.subscribe($event)}}},[_c('IconFont',{attrs:{"name":"mc-icon-daohuotixing-copy","color":_vm.props.hasSubscribed ? '#bbb' : '#15bb5c',"size":"20px"}})],1):_c('div',{class:[
      'arrive-notice',
      {
        'has-subscribed': _vm.props.hasSubscribed
      }
    ],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.listeners.subscribe($event)}}},[_vm._v(" "+_vm._s(_vm.props.hasSubscribed ? '已订阅' : '到货提醒')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }